import { useEffect } from 'react';
import iconNoPermission from './../../../assets/ei_kayttooikeutta.png';
import { CoverageProduct } from './../../../dto/marketableProduct';
import { type InvalidAgeState } from '../../types/initialState';
import {
  AnalyticsPhaseCategories,
  AnalyticsPhases,
  trackPhase,
} from 'api/analytics-api';
import i18n from 'i18n';
import { ErrorPage } from 'individual/components/ErrorPage';
import { getInitialState } from 'utils';

export default function AgeRestrictionView() {
  const { marketableProduct } = getInitialState() as InvalidAgeState;

  const { minGrantingAge: low, maxGrantingAge: high } =
    marketableProduct.coverages.find(
      (coverage) => coverage.coverageProduct === CoverageProduct.LIFE
    ) ?? {};

  useEffect(() => {
    trackPhase(
      AnalyticsPhaseCategories.STEP,
      AnalyticsPhases.RESTRICTED_ACCESS
    );
  }, []);
  return (
    <ErrorPage
      componentId='lifepurchase-age-restriction'
      headerText={i18n.t('error.restrictedAccess')}
      errorMessageText={i18n.t('error.ageRestriction', {
        low,
        high,
      })}
      image={iconNoPermission}
    />
  );
}
